export enum TimerType {
	num = 'num',
	bar = 'bar',
	circ = 'circ',
}
